import SignupView from './View';

export default SignupView;